import Vue from 'vue'

import ViewFactory from '../../../packages/creator/index'
import Schema from '../../../packages/helper/schema'
import { ROLE } from '../../helper/valueMap'
import renderStatus from '../../helper/renderStatus'
import CollectionDescriptor from '../../../packages/helper/resource'
import { MODE } from '../../../packages/constant'
import { capitalize } from '../../../packages/utils/string'

const cities = [
  ['china', 'guangdong', 'shenzhen'],
  ['china', 'guangdong', 'guangzhou'],
  ['china', 'shandong', 'jinan'],
  ['china', 'shandong', 'qingdao'],
  ['japan', 'fukushima', 'fukushima-shi'],
  ['japan', 'fukushima', 'shilakawa-shi'],
  ['japan', 'kumamoto', 'kumamoto-shi'],
  ['japan', 'kumamoto', 'yatsushiro-shi']
]

export default ViewFactory({
  name: 'Parallel View',
  mode: MODE.EDIT_IN_DIALOG,
  data: new CollectionDescriptor('item'),
  schema: [
    new Schema.Hidden('Item ID', 'id', false),
    // 联动控件：a+b
    new Schema.Input('A', 'a', true, { asFilter: true }),
    new Schema.Input('B', 'b', true, { asFilter: true }),
    // deps 中 handler 的返回值的意义是，当依赖改变之后，这个 Schema 的值是多少
    new Schema.Input('A+B', 'c', false, {
      asFilter: true,
      deps: ['a', 'b', (a, b) => (a | 0) + (b | 0)]
    }),
    // 联动控件：国家、省市选择
    // items 使用 Promise 获取数据
    new Schema.Select('Country', 'country', new Promise(resolve => {
      setTimeout(() => resolve([
        { label: 'China', value: 'china' },
        { label: 'Japan', value: 'japan' }
      ]), 3000)
    }), false, {
      asFilter: true,
      render: country => capitalize(country)
    }),
    // deps 的 handler 是一个函数，其中 this 是 new 生成的 Schema
    new Schema.Select('Province', 'province', [], false, {
      asFilter: true,
      deps: ['country', function (country) {
        if (country === 'china') {
          this.items = [
            { label: 'Guangdong', value: 'guangdong' },
            { label: 'Shandong', value: 'shandong' }
          ]
        } else {
          this.items = [
            { label: 'Fukushima', value: 'fukushima' },
            { label: 'Kumamoto', value: 'kumamoto' }
          ]
        }
      }],
      render: province => capitalize(province)
    }),
    new Schema.Select('City', 'city', [], false, {
      asFilter: true,
      deps: ['country', 'province', function (country, province) {
        this.items = new Promise(resolve => {
          setTimeout(() => resolve(cities
            .filter(city => city[0] === country && city[1] === province)
            .map(city => ({
              label: city[2][0].toUpperCase() + city[2].substr(1),
              value: city[2]
            }))
          ), 1000)
        })
      }],
      render: city => capitalize(city)
    })
  ],
  actions: ['edit'],
  hooks: [
    {
      label: 'Show route',
      handler(router, route) {
        Vue.prototype.$message(`Route path is: ${route.path}`)
      }
    }
  ],
  options: {
    columnEditable: true
  },
  parallelResource: [
    {
      data: new CollectionDescriptor('role'),
      schema: [
        new Schema.Input('Role ID', 'role_id', false, {
          editable: false,
          asFilter: true,
          render: (value, row) => row['id']
        }),
        new Schema.Input('Role Name', 'name', true),
        new Schema.Select('Status', 'status', [
          ...ROLE.STATUS.map((item, index) => ({
            label: item,
            value: index
          }))
        ], true, {
          asFilter: true,
          render: (value) => renderStatus({
            type: ROLE.STATUS_CLASS[value],
            content: ROLE.STATUS[value]
          })
        }),
        new Schema.Datetime('Create Time', 'ctime', false, {
          editable: false
        }),
        new Schema.Tree('Permission', 'permission_list', state => state.user.permissionTree, true, {
          editable: true,
          inTable: false,
          asFilter: false
        })
      ],
      actions: [
        'edit'
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./examples/views/lists/parallel.js